import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { Page } from '../../datatypes/Page';
import commonApi from '../../api/common.api';

type PagesStateType = {
  loading: boolean;
  pages: Page[];
  error: boolean;
};
const initialState: PagesStateType = {
  loading: true,
  pages: [],
  error: false,
};

export const pagesSlice = createSlice({
  name: 'pages',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(fetchPageContent.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPageContent.fulfilled, (state, action) => {
        const page = state.pages
          .filter((page: any) => page)
          .find((page: any) => page.id === action.payload.id);
        if (!page) {
          state.pages = state.pages.concat(action.payload);
        }
        state.loading = false;
      })
      .addCase(fetchPageContent.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});

export const getPageBySlug = (state: RootState, slug: string) =>
  state.pages.pages.find((page: Page) => page.slug === slug);

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(fetchPageContent(PAGECODE))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const fetchPageContent = createAsyncThunk(
  'page/fetchPageContent',
  async (slug: string) => {
    const response = await commonApi().getPageContent(slug);
    // The value we return becomes the `fulfilled` action payload
    return response;
  },
);
export default pagesSlice.reducer;
